import { render } from "./gdpr.vue?vue&type=template&id=68918e14"
import script from "./gdpr.vue?vue&type=script&lang=js"
export * from "./gdpr.vue?vue&type=script&lang=js"

import "./gdpr.vue?vue&type=style&index=0&id=68918e14&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__